<template>
  <view id="app">
    <slot></slot>
  </view>
</template>
<script>
	export default {
		onLaunch: function() {
			// 应用启动时执行登录校验
			this.checkLogininStaus();
			
			console.log('App Launch')
			// 预加载主要页面，减少切换闪烁
			this.preloadPages();
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		},
		methods:{
			checkLogininStaus(){
				console.log("打开时判断登录状态")
				// Todo 需要将这个判断加到每次请求之前判断是否登录.
				 
				// 获取本地存储的登录状态
				const token = uni.getStorageSync('token');
				console.log('当前登录token',token);
				if(!token){
					//跳转首页
					uni.reLaunch({
					    url: '/subpackage/login/login', // 你的登录页完整路径
					    fail: (err) => {
					    console.error('跳登录页失败', err);
					    }
					});
					return;
				}
				// 后端过滤器自动在调用方法时验证并刷新了token
				this.refreshToken();
				
			},
			refreshToken() {
			    // 调用后端接口刷新 token，更新本地存储
				
			},
			preloadPages() {
				// APP平台生效，其它平台调用无影响
				const pages = [
					'/pages/index/index',
					'/subpackage/manager/progress',
					'/subpackage/user/mine',
					'/subpackage/user/my-projects'
				];
				pages.forEach(url => {
					try { uni.preloadPage({ url }); } catch(e) {}
				});
			}
		}
	}
</script>

<style>
page {
  margin: 0;
  padding: 0;
}
</style>
